import AppService from "./app-service"

export default class FinancialNatureService extends AppService {

  constructor() {
    super({ path: "financial-natures" })
  }

  static get TYPE_ICONS() {
    return {
      income: { icon: "plus circle blue icon", description: "Receita" },
      expense: { icon: "minus circle red icon", description: "Despesa" },
    }
  }
}